/* eslint-disable max-len */
// #################################################### AUTH PART ######################################################

export const AUTH = '/auth'
export const LOGIN = `${AUTH}/login`
export const FORGOT_PASSWORD = `${AUTH}/forgot-password`
export const RECOVERY_PASSWORD = `${AUTH}/recovery-password/:token`

// #################################################### APP PART #######################################################
export const APP = '/app'

// DASHBOARD
export const DASHBOARD = `${APP}/dashboard`
export const DASHBOARD_GROWTH = `${DASHBOARD}/growth`
export const DASHBOARD_HEALTH = `${DASHBOARD}/health`
export const DASHBOARD_FEED = `${DASHBOARD}/feed`
export const DASHBOARD_ENVIRONMENT = `${DASHBOARD}/environment`
export const HOME = `${APP}/home`
export const SETTINGS = `${APP}/settings`
export const GETTING_STARTED = `${APP}/getting-started`

// APPS
export const APPS = `${APP}/apps`
export const SLA_MONITOR = `${APPS}/sla-monitor`
export const SEA_LICE = `${APPS}/sea-lice`
export const PEW = `${APPS}/pew`
export const SALES_PREDICTION = `${APPS}/sales-prediction`
export const HEALTH_MONITOR = `${APPS}/health-monitor`
export const CAGE_COMPARE = `${APPS}/cage-compare`
export const LOGBOOK = `${APPS}/logbook`
export const DAILY_LOGBOOK = `${APPS}/daily-logbook`
export const SALES_DASHBOARD = `${APPS}/sales-dashboard`
export const SENSORS_MONITOR = `${APPS}/sensors-monitor`
export const ECTO_MAPS = `${APPS}/ecto-maps`
export const ECTO_DASHBOARDS = `${APPS}/ecto-dashboards`
export const ECTO_DASHBOARDS_CAM = `${APPS}/cam-ecto-dashboards`
export const ECTO_DASHBOARDS_VQS = `${APPS}/vqs-ecto-dashboards`
export const ECTO_AQC_SATELLITES_DASHBOARDS = `${APPS}/aqc-satellites-dashboards`
export const ECTO_MULTIEXPORT_SATELLITES_DASHBOARDS = `${APPS}/satellites-dashboards`
export const MONITORS_AND_ALERTS = `${APPS}/monitors-and-alerts`
export const DAILY_LOGBOOK_STATUS = `${APPS}/dl-status`
export const DATA_BROWSER = `${APPS}/data-browser`
export const LOGBOOK_FORM = `${APPS}/logbook-form`
export const SEAWATER_MORTALITY = `${APPS}/seawater-mortality`
export const OVA_MORTALITY = `${APPS}/ova-mortality`
export const BIOMASS_SENSORS = `${APPS}/biomass-and-sensors`
export const TRANSFER_PERFORMANCE = `${APPS}/transfer-performance`
export const MY_SEAWATER_SITES = `${APPS}/my-seawater-sites`
export const WEATHER = `${APPS}/weather`
export const MORTALITY_FORECAST = `${APPS}/mortality-forecast`
export const SAMPLING_DISTRIBUTIONS_AND_FREQUENCY = `${APPS}/sampling-distribution-and-frequency`
export const STOCKING = `${APPS}/stoking`
export const LOT_TRACEABILITY = `${APPS}/lot-traceability`
export const FRESHWATER_PRODUCTION = `${APPS}/freshwater-production`
export const MY_JOBS = `${APPS}/my-jobs`
export const PROJECTED_SITES_MANAGER = `${APPS}/projected-sites-manager`
export const MANAGEMENT_UI = `${APPS}/management-ui`
export const LOOKUP_TABLES = `${APPS}/lookup-tables`
export const JOBS_TRIGGERS = `${APPS}/jobs-triggers`
export const PDF_REPORTS = `${APPS}/pdf-reports-library`

// USER
export const LOGOUT = `${APP}/logout`
export const USER_LIST = `${APP}/users`
export const USER_CREATE = `${USER_LIST}/create`
export const USER_EDIT = `${USER_LIST}/{:id}`
export const USER_EDIT_PATTERN = `${USER_LIST}/:id(create|\\d+)?`

// PROFILE
export const PROFILE = `${APP}/profile`
export const PROFILE_PERSONAL_INFO = `${PROFILE}/personal-info`
export const PROFILE_NOTIFICATIONS = `${PROFILE}/notifications`

// USER GROUP
export const USER_GROUP_LIST = `${APP}/user-groups`
export const USER_GROUP_CREATE = `${USER_GROUP_LIST}/create`
export const USER_GROUP_EDIT = `${USER_GROUP_LIST}/{:id}`
export const USER_GROUP_EDIT_PATTERN = `${USER_GROUP_LIST}/:id(create|\\d+)?`

// LICENSEE
export const LICENSEE_LIST = `${APP}/licensees`
export const LICENSEE_CREATE = `${LICENSEE_LIST}/create`
export const LICENSEE_EDIT = `${LICENSEE_LIST}/{:id}`
export const LICENSEE_EDIT_PATTERN = `${LICENSEE_LIST}/:id(create|\\d+)?`

// APPLICATION
export const APPLICATION_LIST = `${APP}/applications`
export const APPLICATION_CREATE = `${APPLICATION_LIST}/create`
export const APPLICATION_EDIT = `${APPLICATION_LIST}/{:id}`
export const APPLICATION_EDIT_PATTERN = `${APPLICATION_LIST}/:id(create|\\d+)?`

// LICENSEE-APPLICATION
export const LICENSEE_APPLICATION_LIST = `${APP}/licensee-application`
export const LICENSEE_APPLICATION_CREATE = `${LICENSEE_APPLICATION_LIST}/create`
export const LICENSEE_APPLICATION_EDIT = `${LICENSEE_APPLICATION_LIST}/{:id}`
export const LICENSEE_APPLICATION_EDIT_PATTERN = `${LICENSEE_APPLICATION_LIST}/:id(create|\\d+)?`

// FEATURE FLAGS
export const FEATURE_FLAGS = `${APP}/feature-flags`
export const FEATURE_FLAGS_EDIT = `${FEATURE_FLAGS}/{:id}`
export const FEATURE_FLAGS_EDIT_PATTERN = `${FEATURE_FLAGS}/:id(\\d+)?`

// SISENSE
export const SISENSE_LIST = `${APP}/sisense`
export const SISENSE_CREATE = `${SISENSE_LIST}/create`
export const SISENSE_EDIT = `${SISENSE_LIST}/{:id}`
export const SISENSE_EDIT_PATTERN = `${SISENSE_LIST}/:id(create|\\d+)?`

// SITE
export const SITE_LIST = `${APP}/sites`
export const SITE_CREATE = `${SITE_LIST}/create`
export const SITE_EDIT = `${SITE_LIST}/{:id}`
export const SITE_EDIT_PATTERN = `${SITE_LIST}/:id(create|\\d+)?`

// SITE GROUP
export const SITE_GROUP_LIST = `${APP}/site-groups`
export const SITE_GROUP_CREATE = `${SITE_GROUP_LIST}/create`
export const SITE_GROUP_EDIT = `${SITE_GROUP_LIST}/{:id}`
export const SITE_GROUP_EDIT_PATTERN = `${SITE_GROUP_LIST}/:id(create|\\d+)?`

// LOCUS
export const LOCUS_LIST = `${APP}/locuses`
export const LOCUS_CREATE = `${LOCUS_LIST}/create`
export const LOCUS_EDIT = `${LOCUS_LIST}/{:id}`
export const LOCUS_EDIT_PATTERN = `${LOCUS_LIST}/:id(create|\\d+)?`

// LOCUS GROUP
export const LOCUS_GROUP_LIST = `${APP}/locus-groups`
export const LOCUS_GROUP_CREATE = `${LOCUS_GROUP_LIST}/create`
export const LOCUS_GROUP_EDIT = `${LOCUS_GROUP_LIST}/{:id}`
export const LOCUS_GROUP_EDIT_PATTERN = `${LOCUS_GROUP_LIST}/:id(create|\\d+)?`

// JOBS WORKFLOW
export const JOBS_WORKFLOW_ADMIN = `${APP}/jobs-admin`
export const JOB_WORKFLOWS = `${JOBS_WORKFLOW_ADMIN}/jobs`
export const JOB_WORKFLOW_TASKS = `${JOBS_WORKFLOW_ADMIN}/tasks`
export const JOB_WORKFLOW_INPUTS = `${JOBS_WORKFLOW_ADMIN}/inputs`
export const JOB_WORKFLOW_INPUT_ITEMS = `${JOBS_WORKFLOW_ADMIN}/input-items`
export const JOB_WORKFLOW_INPUT_GROUPS = `${JOBS_WORKFLOW_ADMIN}/input-groups`
export const JOB_WORKFLOW_TASKS_CREATE = `${JOB_WORKFLOW_TASKS}/create`
export const JOB_WORKFLOW_TASKS_EDIT = `${JOB_WORKFLOW_TASKS}/{:id}`
export const JOB_WORKFLOW_TASKS_EDIT_PATTERN = `${JOB_WORKFLOW_TASKS}/:id(create|\\d+)?`
export const JOB_WORKFLOWS_JOB_EDIT = `${JOB_WORKFLOWS}/{:id}`
export const JOB_WORKFLOWS_JOB_CREATE = `${JOB_WORKFLOWS}/create`
export const JOB_WORKFLOWS_JOB_EDIT_PATTERN = `${JOB_WORKFLOWS}/:id(create|\\d+)?`
export const JOB_WORKFLOW_INPUTS_CREATE = `${JOB_WORKFLOW_INPUTS}/create`
export const JOB_WORKFLOW_INPUTS_EDIT = `${JOB_WORKFLOW_INPUTS}/{:id}`
export const JOB_WORKFLOW_INPUTS_EDIT_PATTERN = `${JOB_WORKFLOW_INPUTS}/:id(create|\\d+)?`
export const JOB_WORKFLOW_INPUT_ITEMS_EDIT_PATTERN = `${JOB_WORKFLOW_INPUT_ITEMS}/:id(create|\\d+)?`
export const JOB_WORKFLOW_INPUT_GROUPS_CREATE = `${JOB_WORKFLOW_INPUT_GROUPS}/create`
export const JOB_WORKFLOW_INPUT_GROUPS_EDIT = `${JOB_WORKFLOW_INPUT_GROUPS}/{:id}`
export const JOB_WORKFLOW_INPUT_GROUPS_EDIT_PATTERN = `${JOB_WORKFLOW_INPUT_GROUPS}/:id(create|\\d+)?`

// Projected sites manager
export const PROJECTED_SITES_MANAGER_SEAWATER_SITE = `${PROJECTED_SITES_MANAGER}/{:type}/{:snapshot}/{:id}/{:specie}/{:year}`
export const PROJECTED_SITES_MANAGER_FRESHWATER_CLIENT = `${PROJECTED_SITES_MANAGER}/{:type}/{:snapshot}/{:id}`
export const PROJECTED_SITES_MANAGER_SITE_PATTERN = `${PROJECTED_SITES_MANAGER}/:type/:snapshot/:id(\\d+)?/:specie(\\d+)?/:year(\\d+)?`

// Lookup tables
export const LOOKUP_TABLES_SINGLE_TABLE = `${LOOKUP_TABLES}/:id`

// STATISTIC
export const STATISTICS = `${APP}/stat`
export const AUDIT = `${APP}/audit`
export const SATELLITE = `${APP}/satellite`
export const MORTALITY = `${STATISTICS}/mortality`

// DIGITAL LOG
export const DIGITAL_LOG = `${APP}/dl`
export const DL_MORTALITY = `${DIGITAL_LOG}/mortality`
export const DL_WEIGHT = `${DIGITAL_LOG}/weight`
export const DL_NEW_ENTRY = `${DIGITAL_LOG}/entry`
export const DL_MY_LOG = `${DIGITAL_LOG}/mylog`
export const DL_HISTORY = `${DIGITAL_LOG}/history`

// VIETNAM_DEMO_ROUTES
export const ENTRY = `${APP}/entry`
export const VIEW = `${APP}/view`
export const ANALYTICS_GROWTH = `${APP}/analytics/growth`
export const ANALYTICS_SURVIVAL = `${APP}/analytics/survival`
export const ANALYTICS_DISEASE = `${APP}/analytics/disease`

// TRANSLATIONS
export const TRANSLATIONS = `${APP}/translations`
export const TRANSLATIONS_JOB_WORKFLOW_TABLE_LIST = `${TRANSLATIONS}/job-workflow`
export const TRANSLATIONS_JOB_WORKFLOW_EDIT = `${TRANSLATIONS_JOB_WORKFLOW_TABLE_LIST}/{:id}`
export const TRANSLATIONS_JOB_WORKFLOW_EDIT_PARENT = `${TRANSLATIONS_JOB_WORKFLOW_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_JOB_WORKFLOW_TASK_TABLE_LIST = `${TRANSLATIONS}/job-workflow-tasks`
export const TRANSLATIONS_JOB_WORKFLOW_TASK_EDIT = `${TRANSLATIONS_JOB_WORKFLOW_TASK_TABLE_LIST}/{:id}`
export const TRANSLATIONS_JOB_WORKFLOW_TASK_EDIT_PARENT = `${TRANSLATIONS_JOB_WORKFLOW_TASK_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_JOB_WORKFLOW_INPUT_TABLE_LIST = `${TRANSLATIONS}/job-workflow-inputs`
export const TRANSLATIONS_JOB_WORKFLOW_INPUT_EDIT = `${TRANSLATIONS_JOB_WORKFLOW_INPUT_TABLE_LIST}/{:id}`
export const TRANSLATIONS_JOB_WORKFLOW_INPUT_EDIT_PARENT = `${TRANSLATIONS_JOB_WORKFLOW_INPUT_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_LOGBOOK_EVENT_TABLE_LIST = `${TRANSLATIONS}/logbook-event`
export const TRANSLATIONS_LOGBOOK_EVENT_EDIT = `${TRANSLATIONS_LOGBOOK_EVENT_TABLE_LIST}/{:id}`
export const TRANSLATIONS_LOGBOOK_EVENT_EDIT_PARENT = `${TRANSLATIONS_LOGBOOK_EVENT_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_TABLE_LIST = `${TRANSLATIONS}/logbook-event-category`
export const TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_EDIT = `${TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_TABLE_LIST}/{:id}`
export const TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_EDIT_PARENT = `${TRANSLATIONS_LOGBOOK_EVENT_CATEGORY_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_LOGBOOK_FORM_TABLE_LIST = `${TRANSLATIONS}/logbook-form`
export const TRANSLATIONS_LOGBOOK_FORM_EDIT = `${TRANSLATIONS_LOGBOOK_FORM_TABLE_LIST}/{:id}`
export const TRANSLATIONS_LOGBOOK_FORM_EDIT_PARENT = `${TRANSLATIONS_LOGBOOK_FORM_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_MONITORING_ALERTS_TABLE_LIST = `${TRANSLATIONS}/monitoring-alerts`
export const TRANSLATIONS_MONITORING_ALERTS_EDIT = `${TRANSLATIONS_MONITORING_ALERTS_TABLE_LIST}/{:id}`
export const TRANSLATIONS_MONITORING_ALERTS_EDIT_PARENT = `${TRANSLATIONS_MONITORING_ALERTS_TABLE_LIST}/:id(\\d+)?`

export const TRANSLATIONS_SENSOR_TYPE_TABLE_LIST = `${TRANSLATIONS}/sensor-type`
export const TRANSLATIONS_SENSOR_TYPE_EDIT = `${TRANSLATIONS_SENSOR_TYPE_TABLE_LIST}/{:id}`
export const TRANSLATIONS_SENSOR_TYPE_EDIT_PARENT = `${TRANSLATIONS_SENSOR_TYPE_TABLE_LIST}/:id(\\d+)?`

// #################################################### EXCEPTIONS PART ################################################
export const ERROR = '/error'
export const ERROR_403 = `${ERROR}/403`
export const ERROR_404 = `${ERROR}/404`
export const ERROR_500 = `${ERROR}/500`
